// Client-safe helpers for the hidden-until-go-live trauma pages. No content here.
import { TRAUMA_COURSE_IDS } from "./ids";

/** While hidden for this viewer: temporary (302) redirect home. */
export function traumaGateRedirect(canView: boolean): { to: "/"; statusCode: 302 } | null {
  return canView ? null : { to: "/", statusCode: 302 };
}

/** Sitemap entries — only when the feature is live. */
export function traumaSitemapUrls(enabled: boolean, base: string): { loc: string }[] {
  if (!enabled) return [];
  return [{ loc: `${base}/courses` }, ...TRAUMA_COURSE_IDS.map((id) => ({ loc: `${base}/courses/trauma/${id}` }))];
}

export function traumaLlmsSection(enabled: boolean, base: string): string {
  if (!enabled) return "";
  return `\n## Courses\n\n- [Childhood wounds mini-courses](${base}/courses): 12 short Arabic courses for mothers, each with 16 scenario questions and 8 short lessons by Dr. Sara Alnahhas.\n`;
}

export function traumaDescription(definition: string, tldr: string, max = 155): string {
  const text = `${definition} ${tldr}`.replace(/\s+/g, " ").trim();
  if (text.length <= max) return text;
  const cut = text.slice(0, max - 1);
  const sp = cut.lastIndexOf(" ");
  return `${(sp > 80 ? cut.slice(0, sp) : cut).trim()}…`;
}
